import { Classes, Styles } from "jss";
import { createUseStyles } from "react-jss";
import { ThemeItem } from "../../../theme";
import { HeaderProps } from ".";
import arrowDown from "../../../assets/img/arrow-down.png";
import translation from "../../../assets/img/translation.png";

export type HeaderClassNames =
  | "header"
  | "headerWrapper"
  | "container"
  | "headerLeftSide"
  | "headerRightSide"
  | "logo"
  | "menuListItems"
  | "menuItem"
  | "menuItemLink"
  | "menuItemIcon"
  | "menuItemText"
  | "translationIcon"
  | "divider"
  | "menuBtn"
  | "menuOpened"
  | "mobileMenuItemLink"
  | "mobileMenuItem"
  | "closeBtn"
  | "mobileMenuList"
  | "translateArrowDown"
  | "translationBox"
  | "languageText"
  | "servicesMenuBox"
  | "serviceMenuItemText"
  | "serviceMenuItemContainer"
  | "openedMenu"
  | "languageItem"
  | "languagesBox"
  | "moileServicesItem"
  | "mobileDynamicItem"
  | "mobileServicesBox"
  | "mobileMenuLogoBox";
export type HeaderClasses = Classes<HeaderClassNames>;
export type HeaderStyles = Styles<HeaderClassNames>;
export type HeaderStylesProps = HeaderProps;

const getStyles: (theme: ThemeItem) => HeaderStyles = (theme: ThemeItem) => ({
  header: {
    zIndex: 999,
    position: "fixed",
    borderBottom: "solid 1px #f4f4f4",
    background: "#F2F2F2",
    boxShadow: "0 1px 2px 0 rgb(0 0 0 / 27%)",
    top: 0,
    width: "100%",
  },
  headerWrapper: {
    width: 1200,
    maxWidth: "90%",
    margin: "0 auto",
  },
  container: {
    display: "flex",
    alignItems: "center",
    paddingTop: 28,
    paddingBottom: 28,
    justifyContent: "space-between",
  },
  headerLeftSide: {
    display: "flex",
    alignItems: "center",
  },
  headerRightSide: {
    display: "flex",
    alignItems: "center",
  },
  mobileMenuItem: { margin: "36px 0" },
  mobileMenuItemLink: {
    fontSize: 20,
    fontWeight: 300,
    borderBottom: "dotted 2px",
    color: "#353535",
  },
  mobileServicesBox: { display: "none" },
  moileServicesItem: {
    color: "black",
    marginLeft: 10,
    fontSize: 16,
    fontWeight: 300,
    padding: [10, 0],
  },
  mobileMenuLogoBox: { position: "absolute", top: 28, left: 110 },
  mobileDynamicItem: { marginBottom: 10 },
  mobileMenuList: { marginLeft: "15%" },
  menuOpened: ({ showMenuMoile = false }) => ({
    boxShadow: showMenuMoile ? "10px 0px 20px #00000036" : "",
    zIndex: 999999,
    display: "flex",
    flexFlow: "column wrap",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: " #ffffff",
    transform: "translate3d(-100%, 0, 0)",
  }),
  logo: {
    width: 120,
  },
  menuListItems: {
    display: "flex",
    position: "relative",
  },
  closeBtn: {
    position: "absolute",
    background: "none",
    border: "none",
    outline: "none",
    top: 25,
    right: 25,
    opacity: 0.8,
  },
  menuBtn: {
    display: "none",
    background: "none",
    border: "none",
    outline: "none",
    marginRight: 10,
  },
  translateArrowDown: {},
  "@media (max-width: 600px)": {
    translateArrowDown: { display: "none !important" },
  },
  "@media (max-width: 992px)": {
    menuListItems: {
      display: "none",
    },
    menuBtn: { display: "block" },
  },
  menuItem: {
    marginLeft: 90,
  },
  menuItemLink: {
    display: "flex",
    alignItems: "center",
  },
  menuItemIcon: {
    backgroundImage: "url(" + arrowDown + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    padding: [0, 5],
  },
  menuItemText: {
    color: "#25262c",
    paddingRight: 8,
    fontWeight: 300,
  },
  translationBox: {
    background: "white",
    position: "relative",
    alignItems: "center",
    borderRadius: 7,
    boxShadow: "0px 1px 4px #d4d4d4",
    cursor: "pointer",
  },
  languageText: {
    margin: [0, 10],
    color: "#707070",
    fontSize: 12,
    fontWeight: 200,
  },
  translationIcon: {
    backgroundImage: "url(" + translation + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    padding: [5, 20],
  },
  divider: {
    margin: [0, 5],
  },
  servicesMenuBox: {
    display: "none",
    background: "white",
    borderRadius: 6,
    boxShadow: "0px 2px 4px #ccc",
    padding: 10,
    position: "absolute",
    left: 90,
    top: 14,
  },
  serviceMenuItemContainer: {
    display: "flex",
    alignItems: "center",
    padding: [8, 40],
    height: 28,
    borderRadius: 6,
    cursor: "pointer",
    transition: ".2s all",
    "&:hover": {
      background: "rgb(251 131 85 / 15%)",
    },
  },
  serviceMenuItemText: {
    fontWeight: 200,
    color: "#25262c",
    fontSize: 13,
    marginLeft: 8,
  },
  openedMenu: {
    display: "flex !important",
  },
  languagesBox: {
    display: "none",
    position: "absolute",
    background: "white",
    width: "100%",
    boxShadow: "rgb(212, 212, 212) 0px 3px 4px",
    borderTop: "solid 1px #f1f1f1",
    borderRadius: "0 0 7px 7px",
  },
  languageItem: {
    borderRadius: 7,
    padding: [4, 10],
    display: "flex",
    alignItems: "center",
    "&:hover": {
      background: "#f3f3f3",
    },
  },
});

const useHeaderStyles: (
  data?: HeaderStylesProps
) => HeaderClasses = createUseStyles<ThemeItem, HeaderClassNames>(getStyles);

export default useHeaderStyles;
